import { gql, useMutation } from "@apollo/client";
import { OnboardingDocument } from "../queries/getOnboardingDocuments";

export interface UploadOnboardingDocumentInput {
    objectKey: string;
    filename: string;
    fileSize: number;
}

export const UPLOAD_ONBOARDING_DOCUMENT = gql`
    mutation UploadOnboardingDocument($channelId: Long!, $input: UploadOnboardingDocumentInput!) {
        uploadOnboardingDocument(channelId: $channelId, input: $input) {
            objectKey
            filename
            fileSize
            uploadedAt
        }
    }
`;

export interface DeleteOnboardingDocumentResponse {
    deleteOnboardingDocument: boolean;
}

export const DELETE_ONBOARDING_DOCUMENT = gql`
    mutation DeleteOnboardingDocument($channelId: Long!, $objectKey: String!) {
        deleteOnboardingDocument(channelId: $channelId, objectKey: $objectKey)
    }
`;

export interface UploadOnboardingDocumentResponse {
    uploadOnboardingDocument: OnboardingDocument;
}

export interface UploadOnboardingDocumentVariables {
    channelId: number;
    input: UploadOnboardingDocumentInput;
}

export interface DeleteOnboardingDocumentVariables {
    channelId: number;
    objectKey: string;
}

export const useUploadOnboardingDocument = () => {
    return useMutation<UploadOnboardingDocumentResponse, UploadOnboardingDocumentVariables>(
        UPLOAD_ONBOARDING_DOCUMENT
    );
};

export const useDeleteOnboardingDocument = () => {
    return useMutation<DeleteOnboardingDocumentResponse, DeleteOnboardingDocumentVariables>(
        DELETE_ONBOARDING_DOCUMENT
    );
};

export const ENQUEUE_CHANNEL_ONBOARDING_DOCUMENT_DOWNLOAD = gql`
    mutation EnqueueChannelOnboardingDocumentDownload($channelId: Long!, $objectKey: String!) {
        enqueueChannelOnboardingDocumentDownload(channelId: $channelId, objectKey: $objectKey)
    }
`;

export interface EnqueueChannelOnboardingDocumentDownloadResponse {
    enqueueChannelOnboardingDocumentDownload: string;
}

export interface EnqueueChannelOnboardingDocumentDownloadVariables {
    channelId: number;
    objectKey: string;
}

export const useEnqueueChannelOnboardingDocumentDownload = () => {
    return useMutation<
        EnqueueChannelOnboardingDocumentDownloadResponse,
        EnqueueChannelOnboardingDocumentDownloadVariables
    >(ENQUEUE_CHANNEL_ONBOARDING_DOCUMENT_DOWNLOAD);
};

